import(/* webpackMode: "eager" */ "C:\\Users\\f_g_h\\OneDrive\\Documentos\\GitHub\\website-v1\\src\\app\\tools\\isa\\isa-start\\page.tsx")